export default "__VITE_ASSET__CN5uknp4__"